import axios from 'axios'

/**
 * This class is used to implement and enable the connection with the backend
 */

export const AxiosRegister = axios.create({
  baseURL: process.env.REACT_APP_JUSTI_API_URL,
  headers: { Authorization: `Bearer ${process.env.REACT_APP_JUSTI_API_KEY}` },
})

export const AxiosClient = axios.create({
  baseURL: process.env.REACT_APP_JUSTI_API_URL,
})

export const AxiosToken = (token: string): void => {
  if (token) {
    AxiosClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    delete AxiosClient.defaults.headers.common['Authorization']
  }
}